import React, {useState, useEffect,} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";
import FinderSelect from 'react-finderselect';
import { Web } from '@material-ui/icons';
import EstruServJson from '../../JSONS/EstruServJson'
import { QRCodeCanvas } from "qrcode.react";


export default ({DadCont, InfIdUse, InfIdConta, IdUse, IdConta, ListEsp, setUsuariosContServ, UsuariosContServ,  Dados, Avisando, Fechar, Id, setAlert, setAlertTipo}) => {

const [Titulo, setTitulo] = useState("Início");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [Img2, setImg2] = useState("../assets/avatarimg.png");
const [Imgs2, setImgs2] = useState("");
const [Imgs1Res, setImgs1Res] = useState("");
const [Nome, setNome] = useState("");
const [Telefone, setTelefone] = useState("");
const [Mensalidade, setMensalidade] = useState("0000");
const [DiaMes, setDiaMes] = useState("00");
const [DiaMesExt, setDiaMesExt] = useState("00");
const [AtualAno, setAtualAno] = useState("0000"); 
const [QuantApp, setQuantApp] = useState("0000");
const [ValorApp, setValorApp] = useState("0000");
const [End, setEnd] = useState("");
const [Num, setNum] = useState("");
const [Bairro, setBairro] = useState("");
const [Cidade, setCidade] = useState("");
const [Estado, setEstado] = useState("");
const [NomeEmp, setNomeEmp] = useState("");
const [NomeApp, setNomeApp] = useState("");
const [AppLimit, setAppLimit] = useState("");
const [TokenMP, setTokenMP] = useState("");
const [KeyMP, setKeyMP] = useState("");
const [WebHookMP, setWebHookMP] = useState("");
const [ReceberMP, setReceberMP] = useState(true);
const [TempAti, setTempAti] = useState(0);
const [Porcen, setPorcen] = useState(0);
const [ListRepres, setListRepres] = useState([]);
const [ListRespTel, setListRespTel] = useState([]);
const [IdRepr, setIdRepr] = useState("");
const [NomeRepr, setNomeRepr] = useState("");
const [SiteApp, setSiteApp] = useState("");
const [Versao, setVersao] = useState("1.0.0");
const [MedidasAtiv, setMedidasAtiv] = useState(true);
const [DadosCliente, setDadosCliente] = useState("");

useEffect(() => {

    PegandoValor() 
       
    }, [])


useEffect(() => {
       ListRepresentante();     
      }, [])
useEffect(() => {
       NomeRepresentante();     
      }, [ListRepres, IdRepr])
useEffect(() => {
      if(InfIdConta){
         PreencherFormulario() 
          
         }   
        }, [InfIdConta])

         const ListRepresentante = async ()=>{
          await Api.TAListRepresentantesSelect(Dados, setListRepres, setListRespTel)
        }

      const NomeRepresentante = async ()=>{
           for(let i in ListRepres){
       
        if(ListRepres[i].id === IdRepr){
          setNomeRepr(ListRepres[i].select)
          }
      
          }
        }
         const handleToggle4 = () => {
    setMedidasAtiv(!MedidasAtiv);
  };

  function QrCodeSite() {
  const siteURL = SiteApp; // coloque o link do site aqui

  return (
    <div >
      
      <QRCodeCanvas
        value={siteURL}
        size={200}            // tamanho do QR Code
        bgColor={"#ffffff"}   // cor de fundo
        fgColor={"#000000"}   // cor do QR
        level={"H"}           // nível de correção de erro (L, M, Q, H)
        includeMargin={true}  // adiciona margem
      />
    
    </div>
  );
}
   const PegandoValor  = ()=>{
  
        // if (navigator.onLine) {
        //   setMsgErro("")
           
        //  Api.TAClientesDadosInicio(IdUse, setDadosCliente);
   
        // } else {
        //   setAlert("Sem Internet");
        //   setAlertTipo("danger");
        // }
      
    }

const PreencherFormulario = () => {
      setImg2(InfIdConta.Logo !== ""? InfIdConta.Logo : "../assets/avatarimg.png" );
      setImgs2(InfIdConta.Logo);
      setImgs1Res(InfIdConta.Logo);
      setNome(InfIdConta.Nome);
      setTelefone(InfIdConta.Telefone);
      setMensalidade(InfIdConta.Mensalidade);
      setDiaMes(InfIdConta.DiaMes);
      setDiaMesExt(InfIdConta.DiaMes)
      setAtualAno(InfIdConta.AtualAno); 
      setQuantApp(InfIdConta.QuantApp);
      setValorApp(InfIdConta.ValorApp);
      setEnd(InfIdConta.End);
      setNum(InfIdConta.Num);
      setBairro(InfIdConta.Bairro);
      setCidade(InfIdConta.Cidade);
      setEstado(InfIdConta.Estado);
      setNomeEmp(InfIdConta.NomeEmp);
      setNomeApp(InfIdConta.NomeApp);
      setAppLimit(InfIdConta.AppLimit);
      setTokenMP(InfIdConta.TokenMP);
      setKeyMP(InfIdConta.KeyMP);
      setWebHookMP(InfIdConta.WebHookMP);
      setReceberMP(InfIdConta.ReceberMP);
      setTempAti(InfIdConta.TempLimitAtiv);
      setIdRepr(InfIdConta.IdRepresentante);
      setSiteApp(InfIdConta.SiteApp)
      setVersao(InfIdConta.Versao)
      setMedidasAtiv(InfIdConta.MedidasAtiv)
  } 
  
  
 const handleToggle1 = () => {
    setAppLimit(!AppLimit);
  };
   const handleToggle2 = () => {
    setReceberMP(!ReceberMP);
  };


  const criando = ()=>{

    var TAAtualAno = parseInt(AtualAno)
    var TAMensalidade = parseInt(Mensalidade)
    var TADiaMes = parseInt(DiaMes)
    var TAQuantApp = parseInt(QuantApp)
    var TAValorApp = parseInt(ValorApp)


    

    if(TAValorApp >= 0){
    if(TAQuantApp >= 0){
    if(TADiaMes > 0 && TADiaMes < 27 ){
    if(TAMensalidade >= 0){
    if(TAAtualAno >= 0){
    if(Nome !=="" && Nome !==" " && Nome !=="  " && Nome !=="   " && Nome !=="    " && Nome !=="     " && Nome !=="      "
    && Nome !=="       " && Nome !=="        " && Nome !=="         " && Nome !=="          " 
    && Nome !=="           " ){
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
       Api.TAEditarClientes(MedidasAtiv, Versao, SiteApp, IdRepr, Id, Dados, Imgs1Res, TempAti, DiaMesExt, ReceberMP, Nome, AppLimit, Imgs2, TokenMP, Telefone, KeyMP, WebHookMP, Mensalidade, DiaMes, AtualAno, QuantApp, ValorApp, NomeApp, NomeEmp, Estado, Cidade, Bairro, Num, End, UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert);
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setMsgErro("Preencha o Nome Completo do Cliente.")
    }
    } else {
        setMsgErro("Atualização por ano só pode Número.")
    }
    } else {
        setMsgErro("Valor Mensalidade só pode Número.")
    }
    } else {
        setMsgErro("Dia do Mês não é valido.")
    }
    } else {
        setMsgErro("Quantidade de App Free só pode Número.")
    }
    } else {
        setMsgErro("Valor de App só pode Número.")
    }
  }

  const CriandoExercicio = ()=>{

      if (navigator.onLine) {
        setMsgErro("")
         
       Api.TACriarExercicioClientes(Id, setPorcen );
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    
  }
  const DownloadImg = ()=>{


    
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
       Api.TADownloadImg(Imgs2, setMsgErro, setLoading, setAlertTipo, setAlert  );
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    
  }

const AtualizandoTelefone = ()=>{



    

    
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
       Api.TAEditarTelClientes(Id, Telefone,  UsuariosContServ, setUsuariosContServ, setMsgErro, setLoading, setAlertTipo, setAlert  );
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    
  }
  const ColocarImg2 = (e)=>{
    const reader = new FileReader()
    reader.onload = () => {
      if(reader.readyState === 2) {
        setImg2(reader.result);
      }
    }
   reader.readAsDataURL(e.target.files[0]);
    setImgs2(e.target.files[0]);
  }
  const ExcImg2 = ()=>{
   
    setImgs2("");
    setImg2("../assets/avatarimg.png");
  }
   const printValue1 = (target) => {
      
      for(let i in ListRepres){
       
        if(ListRepres[i].select === target.value){
         setIdRepr(ListRepres[i].id)
        }
      
      }
     
      
        }
 

        return (
            <>
<div className="content-wrapper">
               
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
            {InfIdConta && Object.keys(InfIdConta).length > 0 &&
                        <>
                        {InfIdConta.MensagemSistem.Ativo &&
                      <div class="alert alert-warning alert-dismissible">
                              <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                              <h5><i class="icon fas fa-exclamation-triangle"></i> Alert!</h5>
                              {InfIdConta.MensagemSistem.Msg}
                            </div>
                        }
                        </>   
                        }
                         {InfIdConta && Object.keys(InfIdConta).length > 0 &&
                        <>
                        {InfIdConta.TempLimitAtiv < new Date().getTime() &&
                      <div class="alert alert-danger alert-dismissible">
                              <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                              <h5><i class="icon fas fa-exclamation-triangle"></i> Alert!</h5>
                             A mensalidade da sua conta vence em {new Date(InfIdConta.TempLimitAtiv).toLocaleDateString('pt-BR')}. Entre em contato com a empresa e realize o pagamento. Caso o pagamento não seja efetuado em até 5 dias após o vencimento, os aplicativos dos seus alunos serão bloqueados. 
                            </div>
                        }
                        </>   
                        }
              <div className="invoice p-3 mb-3">
              {/* title row */}
              
              {/* info row */}
              


              <div className="row invoice-info">
                <div className="col-sm-4 invoice-col">
                  <address>
                  <div className="FotosArqui" >
                    <div className="FotoQuaAnun" >
                      {Img2 === "../assets/avatarimg.png" ?
                         <img src={Img2} alt="imagem" className="FotoQua2" />
                      :
                      <img src={Img2} alt="imagem" className="FotoQua1" />
                      }
                   
                    </div>
                   </div>
                    <strong>Whatsapp Treino App </strong><br />
                    <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>(99) 98413-6843</string><br />
                    <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>Entre Em Contato Conosco Nesse Número.</string><br />
                       <img src={"../assets/TAQrCodeTreinaApp.png"} alt="imagem" className="FotoQua1" />
                     {/* <strong >Endereço</strong><br />
                     <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{End}</string><br />
                   
                     <strong>Número</strong><br />
                      <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{Num}</string><br />
                  
                      <strong>Bairro</strong><br />
                       <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{Bairro}</string><br />
                   
                  <strong>Cidade</strong><br />
                  <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{Cidade}</string><br />
                    
                    <strong>Estado</strong><br />
                     <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{Estado}</string><br /> */}
      
                     
                  </address>
                    </div>
                      <div className="col-sm-4 invoice-col">
                    <address>
                    <strong>Dono da Empresa</strong><br />
                    <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{Nome}</string><br />
                    <strong>Nome da Empresa</strong><br />
                    <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{NomeEmp}</string><br />
                   <strong>Telefone da Empresa</strong><br />
                    <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{Telefone}</string><br />
                    
                    <strong>Nome do App</strong><br />
                     <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{NomeApp}</string><br />
                  
                     <div style={{ textAlign: "center",  }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={null}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: MedidasAtiv ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: MedidasAtiv ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {MedidasAtiv ? "Medidas Ativo" : "Medidas Desativado"}
                          </span>
                        </label>
                      </div> 
                      <div style={{ textAlign: "center",  }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <div
                            onClick={null}
                            style={{
                              width: "60px",
                              height: "30px",
                              background: ReceberMP ? "linear-gradient(90deg, #00c853, #69f0ae)" : "#ccc",
                              borderRadius: "30px",
                              position: "relative",
                              transition: "0.3s"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                background: "#fff",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "2px",
                                left: ReceberMP ? "32px" : "2px",
                                transition: "0.3s",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                              }}
                            ></div>
                          </div>
                          <span style={{ marginLeft: "12px", fontSize: "15px", fontWeight: "bold" }}>
                            {ReceberMP ? "Mp Ativo" : "Mp Desativado"}
                          </span>
                        </label>
                      </div> 
                     
                    
                    </address>
                   </div>
                    <div className="col-sm-4 invoice-col">
                    <address>
                      <strong>Site APP</strong><br />
                      <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{SiteApp}</string><br />
                        <QrCodeSite />
                      <strong>Versão do APP</strong><br />
                       <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{Versao}</string><br />
                       
                    <strong>Atualização Por Ano</strong><br />
                     <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{AtualAno}</string><br />
                    
                   {DadCont === "Cliente" &&
                   <>
                   
                  
                     <strong>Dia do Mês do Vencimento</strong><br />
                      <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{DiaMes}</string><br />
                    {Mensalidade &&
                    <>
                    <strong>Valor Mensalidade</strong><br />
                      <string style={{ wordWrap: "break-word", whiteSpace: "normal" }}>{Mensalidade.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</string><br />
                  </>
                    }
                    
                    
                      {AppLimit &&
                        <>
                        
                      
                         <strong>Quantidade de App Free</strong><br />
                          <string>{QuantApp}</string><br />
                    
                     <strong>Valor de App</strong><br />
                     <string>{ValorApp.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</string><br />
                   
                      </>
                      }
                  
                       </>
                      }
                    
                    
                   
                    
                   
                     
                    </address>
                   </div>
              </div>
              <div className="row no-print">
              </div>
              
            
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}